import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";
import Seo from "../components/Seo";

const NotFound = () => {
  return (
    <div className="py-32 text-center" data-testid="page-not-found">
      <Seo title="Page Not Found" noindex />
      <div className="container-x">
        <span className="text-xs uppercase tracking-[0.22em] text-primary font-semibold">
          Page not found
        </span>
        <h1 className="mt-6 font-heading text-5xl sm:text-6xl font-medium text-ink-900">
          Even here, you are not lost.
        </h1>
        <p className="mt-4 text-ink-700 max-w-md mx-auto">
          The page you're looking for may have moved. Let's find you a gentler path.
        </p>
        <Link
          to="/"
          data-testid="notfound-home-btn"
          className="mt-8 inline-flex items-center gap-2 bg-primary text-white rounded-full px-7 py-3.5 font-semibold hover:bg-primary-dark transition-all"
        >
          <ArrowLeft size={18} weight="bold" />
          Back to Home
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
